<template>
  <div>
    <h3 class="productblock-title">Latest</h3>
    <div class="row latest-grid product-grid">
      <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 product-grid-item">
        <div class="product-thumb transition">
          <div class="image product-imageblock">
            <a href="#"
              ><img
                src="@/assets/image/product/1product50x59.jpg"
                alt="iPod Classic"
                title="iPod Classic"
                class="img-responsive"
            /></a>
            <div class="button-group">
              <button
                type="button"
                class="wishlist"
                data-toggle="tooltip"
                title="Add to Wish List"
              >
                <i class="fa fa-heart-o"></i>
              </button>
              <button type="button" class="addtocart-btn">
                Add to Cart
              </button>
              <button
                type="button"
                class="compare"
                data-toggle="tooltip"
                title="Compare this Product"
              >
                <i class="fa fa-exchange"></i>
              </button>
            </div>
          </div>
          <div class="caption product-detail">
            <h4 class="product-name">
              <a href="#" title="iPod Classic">iPod Classic</a>
            </h4>
            <p class="price product-price">
              $122.00<span class="price-tax">Ex Tax: $100.00</span>
            </p>
            <div class="rating">
              <span class="fa fa-stack"
                ><i class="fa fa-star fa-stack-2x"></i
                ><i class="fa fa-star-o fa-stack-2x"></i
              ></span>
              <span class="fa fa-stack"
                ><i class="fa fa-star fa-stack-2x"></i
                ><i class="fa fa-star-o fa-stack-2x"></i
              ></span>
              <span class="fa fa-stack"
                ><i class="fa fa-star fa-stack-2x"></i
                ><i class="fa fa-star-o fa-stack-2x"></i
              ></span>
              <span class="fa fa-stack"
                ><i class="fa fa-star-o fa-stack-2x"></i
              ></span>
              <span class="fa fa-stack"
                ><i class="fa fa-star-o fa-stack-2x"></i
              ></span>
            </div>
          </div>
          <div class="button-group">
            <button
              type="button"
              class="wishlist"
              data-toggle="tooltip"
              title="Add to Wish List"
            >
              <i class="fa fa-heart-o"></i>
            </button>
            <button type="button" class="addtocart-btn">
              Add to Cart
            </button>
            <button
              type="button"
              class="compare"
              data-toggle="tooltip"
              title="Compare this Product"
            >
              <i class="fa fa-exchange"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 product-grid-item">
        <div class="product-thumb transition">
          <div class="image product-imageblock">
            <a href="#"
              ><img
                src="@/assets/image/product/2product50x59.jpg"
                alt="iPod Classic"
                title="iPod Classic"
                class="img-responsive"
            /></a>
            <div class="button-group">
              <button
                type="button"
                class="wishlist"
                data-toggle="tooltip"
                title="Add to Wish List"
              >
                <i class="fa fa-heart-o"></i>
              </button>
              <button type="button" class="addtocart-btn">
                Add to Cart
              </button>
              <button
                type="button"
                class="compare"
                data-toggle="tooltip"
                title="Compare this Product"
              >
                <i class="fa fa-exchange"></i>
              </button>
            </div>
          </div>
          <div class="caption product-detail">
            <h4 class="product-name">
              <a href="#" title="iPod Classic">iPod Classic</a>
            </h4>
            <p class="price product-price">
              $122.00<span class="price-tax">Ex Tax: $100.00</span>
            </p>
            <div class="rating">
              <span class="fa fa-stack"
                ><i class="fa fa-star fa-stack-2x"></i
                ><i class="fa fa-star-o fa-stack-2x"></i
              ></span>
              <span class="fa fa-stack"
                ><i class="fa fa-star fa-stack-2x"></i
                ><i class="fa fa-star-o fa-stack-2x"></i
              ></span>
              <span class="fa fa-stack"
                ><i class="fa fa-star fa-stack-2x"></i
                ><i class="fa fa-star-o fa-stack-2x"></i
              ></span>
              <span class="fa fa-stack"
                ><i class="fa fa-star-o fa-stack-2x"></i
              ></span>
              <span class="fa fa-stack"
                ><i class="fa fa-star-o fa-stack-2x"></i
              ></span>
            </div>
          </div>
          <div class="button-group">
            <button
              type="button"
              class="wishlist"
              data-toggle="tooltip"
              title="Add to Wish List"
            >
              <i class="fa fa-heart-o"></i>
            </button>
            <button type="button" class="addtocart-btn">
              Add to Cart
            </button>
            <button
              type="button"
              class="compare"
              data-toggle="tooltip"
              title="Compare this Product"
            >
              <i class="fa fa-exchange"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 product-grid-item">
        <div class="product-thumb transition">
          <div class="image product-imageblock">
            <a href="#"
              ><img
                src="@/assets/image/product/3product50x59.jpg"
                alt="iPod Classic"
                title="iPod Classic"
                class="img-responsive"
            /></a>
            <div class="button-group">
              <button
                type="button"
                class="wishlist"
                data-toggle="tooltip"
                title="Add to Wish List"
              >
                <i class="fa fa-heart-o"></i>
              </button>
              <button type="button" class="addtocart-btn">
                Add to Cart
              </button>
              <button
                type="button"
                class="compare"
                data-toggle="tooltip"
                title="Compare this Product"
              >
                <i class="fa fa-exchange"></i>
              </button>
            </div>
          </div>
          <div class="caption product-detail">
            <h4 class="product-name">
              <a href="#" title="iPod Classic">iPod Classic</a>
            </h4>
            <p class="price product-price">
              $122.00<span class="price-tax">Ex Tax: $100.00</span>
            </p>
            <div class="rating">
              <span class="fa fa-stack"
                ><i class="fa fa-star fa-stack-2x"></i
                ><i class="fa fa-star-o fa-stack-2x"></i
              ></span>
              <span class="fa fa-stack"
                ><i class="fa fa-star fa-stack-2x"></i
                ><i class="fa fa-star-o fa-stack-2x"></i
              ></span>
              <span class="fa fa-stack"
                ><i class="fa fa-star fa-stack-2x"></i
                ><i class="fa fa-star-o fa-stack-2x"></i
              ></span>
              <span class="fa fa-stack"
                ><i class="fa fa-star-o fa-stack-2x"></i
              ></span>
              <span class="fa fa-stack"
                ><i class="fa fa-star-o fa-stack-2x"></i
              ></span>
            </div>
          </div>
          <div class="button-group">
            <button
              type="button"
              class="wishlist"
              data-toggle="tooltip"
              title="Add to Wish List"
            >
              <i class="fa fa-heart-o"></i>
            </button>
            <button type="button" class="addtocart-btn">
              Add to Cart
            </button>
            <button
              type="button"
              class="compare"
              data-toggle="tooltip"
              title="Compare this Product"
            >
              <i class="fa fa-exchange"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Latest",
  data() {
    return {};
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/product/Latest.vue